import axiosInstance from '../utils/axiosInstance.js';
import { route_get_backups, route_get_backup_download, route_upload_backup } from '../constants/BackendRoutes.js';

/**
 * Fetches the list of backup file list
 */
export async function fetchBackupFileList() {
  try {
    // Fetch firmware list from backend
    const url = `${route_get_backups}`;
    console.log(url);
    const response = await axiosInstance.get(url);
    return response.data.backup;
  } catch (error) {
    if ('status' in error)
    {
      console.log(`Backend not responding: ${error.status} error`);
    }
    else
    {
      console.error("Error fetching backup filelist:", error);
    }
    return null;
  }
}


export async function downloadBackup(filename) {
    const url = `${route_get_backup_download}/${encodeURIComponent(filename)}`;
    const response = await axiosInstance.get(
        url,
        {
            responseType: "blob"
        }
    );

    return response.data;
}


export async function uploadBackup(file) {

  try {

    const formData = new FormData();

    formData.append("backup", file);
    // Allow 120 seconds for the file upload
    const response = await axiosInstance.post(
        route_upload_backup,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            timeout: 120000, // 120 seconds
        }
    );
    return response.data;
  }
  catch (error) {
    if (error.response) {
      // Server responded with an error status (400, 500, etc.)
      throw new Error(
        error.response.data?.message || "Upload failed"
      );
    } 
    
    if (error.request) {
      // Request was sent but no response received
      throw new Error("No response from server");
    }

    // Other unknown errors
    throw new Error(error.message || "Something went wrong");
  }
}
